import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Toast,AlertController,Events } from 'ionic-angular';
import { LoginProvider } from '../../providers/login/login';
import { ProfileDetailPage } from '../profile-detail/profile-detail';
import { MyVehiclePage } from '../my-vehicle/my-vehicle';
import { ForgotPassPage } from '../forgot-pass/forgot-pass';
import { ResidentIdCardPage } from '../resident-id-card/resident-id-card';
import { ToastProvider } from '../../providers/toast/toast';
import { ForgotPasswordPage } from '../forgot-password/forgot-password';
import { HomePage } from '../home/home';
import { ExtraProvider } from '../../providers/extra/extra';
import { Platform } from 'ionic-angular/platform/platform';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import { TranslateService } from '@ngx-translate/core';
import { ReferralPage } from '../referral/referral'
import { environment } from '../../environments/environment';
import { MobileAppService } from '../../services/mobile-app';
import { DashboardPage } from '../dashboard/dashboard';
import { Storage } from '@ionic/storage';
import { RequestListPage } from '../request-list/request-list';

@IonicPage()
@Component({
  selector: 'page-profile',
  templateUrl: 'profile.html',
})
export class ProfilePage {

  userData: any = {};
  loading = false;
  tenant = false;
  loginDetail = {};
  isAndroid = true;
  permissions:any
  multipleAccount=[];
  openMultiple = false;
  filteredAccounts =[];
  newUserName:any
  version:any

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    private translate: TranslateService,
    private loginProvider: LoginProvider,
    private toast: ToastProvider,
    private ref: ChangeDetectorRef,
    private extra: ExtraProvider,
    private platform: Platform,
    private imageTools: Ng2ImgToolsService,
    private alertCtrl : AlertController,
    private appService: MobileAppService,
    private storage: Storage,
    public event: Events) {
      this.version=environment.AppVersionCode
    this.isAndroid = this.platform.is('android');
    loginProvider.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });
  	loginProvider.profileDetails().then(val => {
  		if(val){
        this.userData = val;
        this.onSwitch(this.userData,'');
        loginProvider.getUserDetails().then(val => {
          this.loginDetail = val;
     
          if(val.tenant && val.tenant == true){
            this.tenant = true;
          }
        });
  		}
  	});
  }

  onLogOut(){
    this.loginProvider.logOut();
    this.navCtrl.setRoot(HomePage);
  }

  onSwitch(data,newData){
    var params = {
      'identity' : data.phone_no,
      'password' : newData?newData.password:'',
      'user_id' : newData?newData.user_id:null,
      'tenant' : 0 ,
    }
    const alert =  this.alertCtrl.create({
      title: 'Switching To',
      subTitle:this.newUserName,
      message:"..."
    
    });
    if(this.newUserName!=null){
      alert.present();
    }
    
    this.loginProvider.login(params).subscribe((res) => {
     
      if(res.status == 'multipleLogin'){
        this.filteredAccounts =res.data
         console.log(this.userData)
        if(this.userData.designation_name=='Resident'){
        this.filteredAccounts.forEach( a=>{
          if(a.flat_no && a.flat_no==!null ){
            this.multipleAccount.push(a);
          }
        })
    
      }
      else{
        this.multipleAccount=res.data
      }
    }
      else{
      if(res.status == 'error'){
        this.toast.presentToast(res.message);
      }else{
        if(environment.allowRole.indexOf(res.data.role) != -1){
          if(environment.debug) console.log("Login role =>", res.data.role, new Date());
          this.storage.set('loginDetails', res.data).then(val=>{
            if(environment.debug) console.log("storage.get(loginDetails) =>", this.storage.get('loginDetails'));
            this.loginProvider.updateUserRegisterApp(res.data);
            this.event.publish('user:created', res.data);
            if(environment.debug) console.log("Login before switchToWeb() in onEvent() =>", new Date());
            (environment.switchToWeb) ? this.appService.switchToWeb() : this.navCtrl.setRoot(DashboardPage);
          })
         
        }
      }
      }
    })
    alert.dismiss()
  }

  onOpenPassAlert(switchOption,userID,errorMessage,userName){
    this.newUserName =userName;

    const alert =  this.alertCtrl.create({
      title: 'Enter Password',
      subTitle :errorMessage ? errorMessage :'',
      inputs: [
        {
          name: 'password',
          type: 'text',
          placeholder: 'Password *'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Confirm Cancel');
          }
        }, {
          text: 'Switch',
      
          handler: (data) => {
             
            if(data.password){
              var d = {password: data.password,switch:switchOption,user_id:userID}
              this.onSwitch(this.userData,d)
              alert.present();
              
            }
          }
        }
      ]
    });

    alert.present();
  }
  
  changeDp(){
    console.log("change dp entered ")
    this.extra.imgPicker().then(val => {
      var file = 'data:image/jpeg;base64,' + val[0]
      console.log("file upload",file,val)
      if(val[0]!=undefined && val!=undefined){
            this.uploadImage(file);
      }
    });
    
    // if(this.platform.is('ios')){
    // }else{
    //   this.extra.chooseFile().then(val => {
    //     val.fileEntry.getMetadata(metadata => {
    //       if(metadata.size < 4000000){
    //         if(val.file && (val.file.slice(-3) == "jpg" || val.file.slice(-3) == "png" || val.file.slice(-4) == "jpeg")){
    //           this.uploadImage(val.base64File);
    //         }else{
    //           this.toast.presentToast("file should be an image");
    //         }
    //       }else {
    //         this.toast.presentToast("file size is greater than 2mb");
    //       }
    //     });
    //   });
    // }
  }

  onClick(type: string){
    if(type == 'Vehicle'){
      this.navCtrl.push(MyVehiclePage);
    }else{
    	this.navCtrl.push(ProfileDetailPage, {
    		page_title: type,
    		details: this.getDetails(type)
    	});
    }
  }

  uploadImage(image){
    this.loading = true;
    this.loginProvider.changeProfilePicture(image).then(val=>{
      this.loading = false;
      if(val.status == "success"){
        this.loginProvider.profileDetails().then(val => {
          if(val){
            this.userData = val;
            this.storage.get("loginDetails").then((val) => {
              if(val){
                this.loginProvider.updateUserRegisterApp(val);
              }
            });
            this.ref.detectChanges();
          }
        });
        this.toast.presentToast("Profile picture changed");
      }else{
        this.toast.presentToast(val.message);
      }
    }, err=>{
      this.loading = false;
    });
  }

  changeListener($event) : void {
    this.readThis($event.target);
  }
 
  readThis(inputValue: any): void {
    var file:File = inputValue.files[0];
    this.loading = true;
    this.imageTools.resize([file], 500, 500).subscribe(val => {
      var reader = new FileReader();
      reader.readAsDataURL(val); 
      reader.onloadend = () => {
        let base64 = reader.result;
        this.uploadImage(base64);
      }
    }, err => {
      console.log(err);
      this.loading = false;
      this.toast.presentToast("Unable to compress");
    });
  }

  onChangePass(){
    this.navCtrl.push(ForgotPassPage);
  }
  onEditProfile(){
    this.navCtrl.push(RequestListPage);
  }
  onChangeResident(){
    this.navCtrl.push(ResidentIdCardPage);
  }

  getDetails(type: string){
    let owner = [
    {
      info: this.userData.name,
      title: "PROFILE.NAME"
    },
    {
      info: this.userData.phone_no,
      title: "PROFILE.MOBILE"
    },
    {
      info: this.userData.email,
      title: "PROFILE.EMAIL"
    },
    {
      info: this.userData.block,
      title: "PROFILE.BLOCK"
    },
    {
      info: this.userData.tower,
      title: "PROFILE.TOWER"
    },
    {
      info: this.userData.flat_no,
      title: "PROFILE.UNIT"
    },
    {
      info: this.userData.display_unit_no,
      title: "PROFILE.DISPLAY_UNIT_NO"
    },
    {
      info: this.userData.size_sf,
      title: "PROFILE.AREA"
    },
    {
      info: this.userData.flat_category,
      title: "PROFILE.CATEGORY"
    },
    {
      info: this.userData.owner_alt_phone_no,
      title: "PROFILE.ALTERNATE_PHONE_NO"
    },
    {
      info: this.userData.address,
      title: "PROFILE.ADDRESS"
    }
    ];

    let unit = [
    {
      info: this.userData.possession_date,
      title: "PROFILE.POSSESSION_DATE",
      type: "date"
    },
    {
      info: this.userData.maint_start_date,
      title: "PROFILE.MAINTENANCE_START_DATE",
      type: "date"
    },
    {
      info: this.userData.handover_date,
      title: "PROFILE.HANDOVER_DATE",
      type: "date"
    },
    {
      info: this.userData.bill_start_date,
      title: "PROFILE.FIRST_BILL_DATE",
      type: "date"
    },
    {
      info: this.userData.serial_no,
      title: "PROFILE.SERIAL_NO"
    },
    {
      info: this.userData.gstin_no,
      title: "PROFILE.GSTIN_NO"
    },
    {
      info: this.userData.sap_code,
      title: "PROFILE.SAP_CODE"
    },
    {
      info: this.userData.ext_no,
      title: "PROFILE.EXTENSION_NO"
    },
    {
      info: this.userData.pan_no,
      title: "PROFILE.PAN_NO"
    },
    {
      info: this.userData.sec_depo,
      title: "PROFILE.SECURITY_DEPOSIT"
    }
    ];

    let meter = [
    {
      info: this.userData.grid_meter_no,
      title: "PROFILE.METER_NO"
    },
    {
      info: this.userData.grid_demand_load,
      title: "PROFILE.GRID_DEMAND_LOAD"
    },
    {
      info: this.userData.dg_meter_no,
      title: "PROFILE.DG_METER_NO"
    },
    {
      info: this.userData.dg_demand_load,
      title: "PROFILE.DG_DEMAND_LOAD"
    },
    {
      info: this.userData.meter_seal_no,
      title: "PROFILE.METER_SEAL_NO"
    },
    {
      info: (this.userData.is_prepaid)?"Prepaid":"Postpaid",
      title: "PROFILE.METER_BILL_TYPE"
    },
    ];

    let details = {
      Owner: owner,
      Unit: unit,
      Meter: meter,
    }
    return details[type];
  }

  goToReferralPage() {
    this.navCtrl.push(ReferralPage,{})
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProfilePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile/profile.ts